(function ($) {
    'use strict';

    $(function () {

        if ($.validator && !$.validator.methods.regex) {
            $.validator.addMethod(
                "regex",
                function (value, element, regexp) {
                    return this.optional(element) || regexp.test(value);
                },
                "Please check your input."
            );
        }

        $('.delivery_estimate input[name="postcode"]').each(function () {
            if (this.value) return;
            try {
                var saved = sessionStorage.getItem('gk-delivery-postcode') || '';
                if (/^\d{4}$/.test(saved)) this.value = saved;
            } catch (error) { /* ignore */ }
        });

        $(document).on('submit', '.delivery_estimate form', function (event) {
            event.preventDefault();

            const $form = $(this);
            const $container = $form.closest('.delivery_estimate');
            const $result = $container.find('.result');

            $result.html('<i class="fa fa-circle-notch fa-spin" style="font-size:24px;"></i> Please wait while processing your request.');

            const productWeightGrams = Number($container.data('weight')) || 0;
            const productWeightKg = productWeightGrams / 1000;

            const postalCode = String($form.find('input[name="postcode"]').val() || '').replace(/\s+/g, '');
            if (/^\d{4}$/.test(postalCode)) {
                try { sessionStorage.setItem('gk-delivery-postcode', postalCode); } catch (error) { /* ignore */ }
                document.dispatchEvent(new CustomEvent('gk:delivery-postcode', { detail: { postcode: postalCode } }));
            }

            if (!postalCode || productWeightKg <= 0) {
                $result.html("<p class='error'>Sorry unable to process your request this time. Please try again later.</p>");
                return;
            }

            $.ajax({
                type: "POST",
                url: "https://api.grillkingbbqs.com/api/shipping/calculate-shipping-rate",
                data: JSON.stringify({
                    postal_code: postalCode,
                    weight: productWeightKg
                }),
                contentType: "application/json",
                dataType: "json",
                success: function (response) {

                    if (response.success && response.rates) {

                        const rate = response.rates;
                        const breakdown = rate.result || {};

                        $result.html(
                            `<p>Your estimated shipping for this product is <b>$${(breakdown.total || rate.total).toFixed(2)}</b> to ${rate.zone} (includes Country Charge: $${(breakdown.country_charge || 0).toFixed(2)}, Metro: $${(breakdown.metro_charge || 0).toFixed(2)}, Bulky Surcharge: $${(breakdown.bulky_surcharge || 0).toFixed(2)}, Fuel Levy: $${(breakdown.fuel_levy || 0).toFixed(2)}, GST: $${(breakdown.gst || 0).toFixed(2)}).</p>`
                        );

                    } else {
                        $result.html("<p class='error'>No shipping rates available.</p>");
                    }
                },
                error: function (xhr) {
                    const data = xhr.responseJSON;

                    if (data && data.message) {
                        $result.html("<p class='error'>" + data.message + "</p>");
                    } else {
                        $result.html("<p class='error'>An error occurred while fetching rates.</p>");
                    }
                }
            });
        });
    });

})(jQuery);